
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
import PropTypes from 'prop-types';
import { buildContentfulImageURL } from '@utils/image';
import Image from '../../../../../components/Image';
import s from './FactFileImageCarouselSlide.module.scss';
const propTypes = {
    image: PropTypes.shape({
        contentfulId: PropTypes.string,
        contentTypeId: PropTypes.string,
        entryTitle: PropTypes.string,
        image: PropTypes.shape({
            contentfulId: PropTypes.string,
            contentTypeId: PropTypes.string,
            title: PropTypes.string,
            description: PropTypes.string,
            file: PropTypes.shape({
                url: PropTypes.string,
                details: PropTypes.shape({
                    size: PropTypes.number,
                    image: PropTypes.shape({
                        width: PropTypes.number,
                        height: PropTypes.number
                    })
                }),
                fileName: PropTypes.string,
                contentType: PropTypes.string
            })
        }),
        imageCaption: PropTypes.string
    }).isRequired,
    isPreview: PropTypes.bool,
    isActive: PropTypes.bool
};
const FactFileImageCarouselSlide = ({ image, isPreview = false, isActive = false }) => {
    const url = image?.image?.file?.url;
    const imageSet = [
        {
            src: `${buildContentfulImageURL(url, {
                width: 600,
                height: 416,
                fit: 'pad',
                format: 'webp'
            })} 1x, ${buildContentfulImageURL(url, {
                width: 1200,
                height: 832,
                fit: 'pad',
                format: 'webp'
            })} 2x, ${buildContentfulImageURL(url, {
                width: 1800,
                height: 1248,
                fit: 'pad',
                format: 'webp'
            })} 3x`,
            type: 'image/webp'
        },
        {
            src: `${buildContentfulImageURL(url, {
                width: 600,
                height: 416,
                fit: 'pad',
                format: 'jpg'
            })} 1x, ${buildContentfulImageURL(url, {
                width: 1200,
                height: 832,
                fit: 'pad',
                format: 'jpg'
            })} 2x, ${buildContentfulImageURL(url, {
                width: 1800,
                height: 1248,
                fit: 'pad',
                format: 'jpg'
            })} 3x`,
            type: 'image/jpeg'
        },
        {
            src: buildContentfulImageURL(url, { width: 600, height: 416, fit: 'pad', format: 'jpg' })
        },
    ];
    return (<div className={[s.container, isPreview ? s.isPreview : '', isActive ? s.isActive : ''].join(' ')}>
      <Image cover imageSet={imageSet}/>
    </div>);
};
FactFileImageCarouselSlide.propTypes = propTypes;
export default FactFileImageCarouselSlide;

    async function __Next_Translate__getStaticProps__195ca0da772__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'src//FactFile/components/FactFileImageCarousel/FactFileImageCarouselSlide/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__195ca0da772__ as getStaticProps }
  